const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/views/ResetPassword')
const LinkedInLogin = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/views/LinkedInLogin')

import Auth from '@/services/Auth'

export default [
  {
    path: '/account/reset-password/:id/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    beforeEnter: Auth.isGuest,
    meta: {
      title: 'Reset Password'
    }
  },
  {
    path: '/u/sign-in',
    name: 'LoginSelection',
    component: () => import(/* webpackChunkName: "auth" */ './views/LoginSelection.vue'),
    beforeEnter: Auth.isGuest,
    meta: {
      title: 'User Sign In'
    }
  },
  {
    path: '/u/register',
    name: 'SignupSelection',
    component: () => import(/* webpackChunkName: "auth" */ './views/SignupSelection.vue'),
    beforeEnter: Auth.isGuest,
    meta: {
      title: 'User Registration'
    }
  },
  {
    path: '/sign-in',
    name: 'LoginFormv2',
    component: () => import(/* webpackChunkName: "auth" */ './views/LoginFormv2.vue'),
    beforeEnter: Auth.isGuest,
    meta: {
      title: 'Sign In'
    }
  },
  {
    path: '/account/Login',
    name: 'LinkedInLogin',
    component: LinkedInLogin,
    beforeEnter: Auth.isGuest,
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ './views/Register.vue'),
    beforeEnter: Auth.isGuest,
    meta: {
      title: 'Buyer Registration'
    }
  }
]
